import { BASE_URL_PROD } from '../../components/config/keys';
import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from 'react-i18next';
import getTranslation from '../../utils/getTranslation';
import './styles.scss';
import { useSelector, useDispatch } from "react-redux"
import { Container, Row, Col, Modal, CloseButton } from "react-bootstrap"
import { useHistory } from "react-router";
import { soundnotification } from "../../assets/images";
import { apiClient } from "../../actions/api"
import moment from 'moment'
import "moment-timezone"
import 'moment/locale/fr';
import Countdown from 'react-countdown';
import ErrorBoundary from "../../helpers/ErrorBoundary";
import { getRealTherapieTime } from "../../actions/api_interface"

const Page = () => {
  const history = useHistory()
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const { user, formule } = useSelector(state => state.user);
  const { i18n } = useTranslation();
  const [checkconsultation, setCheckconsultation] = useState({})
  const [seancetime, setseancetime] = useState(0)
  const [startDate, setStartDate] = useState(null)
  const [patients, setPatients] = useState([])
  const audioPlayer = useRef(null);

  const [timecall, setTimeCall] = useState(100000)
  const [startcall, setstartcall] = useState(false)
  const [isStarting, setIsStarting] = useState(false)

  useEffect(() => {
    if (!user.user_id || user.google_id !== 'V') {
      history.replace("/")
    }

    checkifconsultation()
  }, [user]);

  function playAudio() {
    audioPlayer.current.play();
  }

  function checkifconsultation() {
    let params = {
      token: user.api_token,
      api_token: user.api_token,
    }

    apiClient().post(`/getconsultation/therapeut`, params)
      .then((res) => {
        if (res.data.success === 'ok') {
          if (res.data.reservation?.heure_rdv) {
            setCheckconsultation(res.data.reservation)
            setPatients(res.data.patients)
            let date = moment.utc(res.data.reservation.date_rdv + "T" + res.data.reservation.heure_rdv + "Z")
            let diff = date.diff(moment.utc(), 'seconds')

            setStartDate(date)

            if (diff <= 0) {
              setTimeCall(0)
            }
            else {
              setTimeCall(diff * 1000)
            }

            setseancetime(getRealTherapieTime(res.data))
          }
          else {
            history.push('/')
          }
        }
      })
  }

  const startDemo = () => {
    if (isStarting) return; // Éviter double-clic
    
    setIsStarting(true);

    // Appeler directement /save/room qui crée la session Vonage
    let params = {
      token: user.api_token,
      api_token: user.api_token,
      patients: patients,
      action: 'deplacerbytherapeut',
    }

    apiClient().post(`/save/room`, params)
      .then((res) => {
        if (res.data.success === 'ok') {
          console.log("✅ Session Vonage créée, redirection...");
          history.push('/room-call/' + checkconsultation?.id + "/r");
        } else {
          console.error("❌ Erreur création session");
          setIsStarting(false);
        }
      })
      .catch(e => {
        console.log("⚠️ Erreur réseau, redirection quand même (session peut être créée)");
        // Rediriger quand même car la session peut être créée malgré l'erreur Pusher
        history.push('/room-call/' + checkconsultation?.id + "/r");
      })
  };

  const handleClose = () => setShow(false);

  const renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      setstartcall(true)
      return (<span>"Maintenant"</span>)
    } else {
      return (<span> {hours}h:{minutes}m:{seconds}s</span>)
    }
  };

  return (
    <div className="home dayli">
      <section className="section2">
        <ErrorBoundary>
          <Container className='listtherapeutes'>
            <div className='row'>
              <Col md={6}>
                <div className='therapeutescontent'>

                  <div className="home-screen">
                    <h1>Salle d'attente - Consultation</h1>
                    <div className='alert alert-warning' style={{ width: '100%' }}>
                      <div style={{}}>
                        <div style={{ marginBottom: '10px' }}></div>
                        <strong>Votre prochaine consultation commence
                          {
                            startcall ? <span> Maintenant</span>
                              : <span> dans
                                {
                                  timecall > 1000 * 60 * 60 * 24
                                    ? <span> plus d'un jour</span>
                                    : <Countdown date={Date.now() + timecall} renderer={renderer} />
                                }
                              </span>

                          }
                        </strong>
                        <br /> <br />
                        <div style={{ marginBottom: '20px' }}></div>

                        <div className='js889'>
                          <input type='checkbox' name='adolesant' value='1' />
                          <span style={{ paddingLeft: '8px' }}>J'ai pris connaissance du dossier patient</span>
                        </div>

                        <div style={{ marginBottom: '20px' }}></div>
                        {
                          startcall && !isStarting ?
                            <a href="javascript:void(0)" onClick={startDemo} className="btnlink marauto">
                              Cliquez pour démarrer la consultation <i className="fa fa-video-camera"></i>
                            </a>
                            : isStarting ?
                              <a href="javascript:void(0)" style={{ background: '#ccc', cursor: 'wait' }} className="btnlink marauto">
                                Démarrage en cours... <i className="fa fa-spinner fa-spin"></i>
                              </a>
                              :
                              <a href="javascript:void(0)" style={{ background: '#ccc', cursor: 'none' }} className="btnlink marauto">
                                Cliquez pour démarrer la consultation <i className="fa fa-video-camera"></i>
                              </a>
                        }
                      </div>
                      <div style={{ marginBottom: '10px' }}></div>
                    </div>

                    <p className="small">Sélectionnez "Autoriser" pour utiliser votre caméra et votre micro pour cet appel si vous y êtes invité.</p>
                  </div>
                </div>
              </Col>

              <Col md={1}></Col>

              <Col md={5}>
                {/* Lister les patients */}
                <div className='therapeutescontent'>
                  <Row className=''>
                    <Col md={12}>
                      <div className='row'>
                        <div className="text-center flowpriceheader">
                          <h2>{patients.length > 1 ? "Les patients" : "Patient"}</h2>
                        </div>
                      </div>
                      <div className='row ps-block--site-features ps-block--site-features-2' style={{ marginBottom: '30px' }}>
                        {
                          patients?.map((item, index) => (
                            <div className='col-md-6' key={index}>
                              <div className='itemimg' style={{
                                backgroundImage: item?.patient?.picture
                                  ? `url(${BASE_URL_PROD + "gestion/public/uploads/" + item?.patient?.picture})`
                                  : "url('/images/default-profile.png')",
                                width: '90px',
                                margin: '0 auto',
                                height: '90px'
                              }}></div>
                              <h3 className='title'>{item?.patient?.name}</h3>
                            </div>
                          ))
                        }
                      </div>

                      <div className='therapeutescontent'>
                        <div className='flexrowtarifs row'>
                          <div className='col-md-12'>
                            <div className="text-center flowpriceheader">
                              <img src={checkconsultation?.tarif?.image} alt="tarif" />
                              <h2>{getTranslation(checkconsultation?.tarif?.titre, i18n.language)}</h2>
                            </div>
                          </div>

                          <div className='item'>
                            <div className='pricebox' style={{ boxShadow: 'none' }}>
                              <h3>{getTranslation(checkconsultation?.formule?.titre, i18n.language)}</h3>
                              <h4>{parseFloat(checkconsultation?.formule?.price).toFixed(2)}€<span><sup>/séance</sup></span></h4>
                              <div className="pricebox-border2"></div>
                              <div className='ttcontent'>
                                <ul className='col-9028-K'>
                                  <li><i className='fa fa-check-circle icochecked'></i> {checkconsultation?.formule?.temps} min</li>
                                  <li><i className='fa fa-check-circle icochecked'></i> {checkconsultation?.formule?.seance} {checkconsultation?.formule?.seance > 1 ? 'séances' : 'séance'}</li>
                                  <li><i className='fa fa-check-circle icochecked'></i> {checkconsultation?.formule?.pack}</li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>

                    <Col md={3}>
                      <div className='actionrdv'>
                        <div className="text-center"></div>
                      </div>
                    </Col>
                  </Row>
                </div>
                {/* End */}
              </Col>
            </div>
            <audio ref={audioPlayer} src={soundnotification} />
          </Container>
        </ErrorBoundary>
      </section>

      <Modal show={show} onHide={handleClose} className='modelhermixtarif' size="xl" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header>
          <CloseButton variant="dark" onClick={handleClose} />
        </Modal.Header>
        <Modal.Body></Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </div>
  );
}

export default Page;